import React, {useState, useEffect, useRef}  from 'react';
import { Link, useLocation, useNavigate, useRoutes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../component/Button";
import { useropen } from '../redux/userInfo';
import { open, close } from '../redux/popupSlice';
import moment from 'moment';

import AlertPopup from "../component/AlertPopup";
import ProductTogetherSendPop from '../component/ProductTogetherSendPop';
import ProductSimplewrite from '../component/ProductSimplewrite';
import ProductDetailwrite from '../component/ProductDetailwrite';
import CustomerWrite from '../component/CustomerWrite';

import * as APIS from "../utils/service";
import MypageleftArea from '../component/MypageleftArea';
import { getMemberinfo } from '../utils/utils';
import ProductTogetherConfirmPop from '../component/ProductTogetherConfirmPop';
import consts from '../libs/consts';
import GuideButton from '../component/GuideButton';
import Guide from '../component/Guide';


export default function Layout({ 
    children, header=null, actives='', footters=true,
    setsell_type=() => {}, 
    setcategory_1=() => {}, 
    setcategory_2=() => {},
    detailFlag= false,
    detailFlag2=false
}) {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const elementRef = useRef(null);

    const { userdata, companylogourl } = useSelector(state => state.userInfo);
    const { configdata } = useSelector(s => s.configReducer);
    

    const [bellshowflag, setbellshowflag] = useState(false);   
    const [producttogethersendflag, setproducttogethersendflag] = useState(false);   
    const [producttogetherconfirmflag, setproducttogetherconfirmflag] = useState(false);   
    
    const [simplewrite, setsimplewrite] = useState(false); 
    const [detailwrite, setdetailwrite] = useState(false); 
    const [customerwirte, setcustomerwirte] = useState(false); 
    const [productIdx, setproductIdx] = useState(false); 
    const [alramdot, setalramdot] = useState(false); 
    const [noticepage, setnoticepage] = useState(0); 
    const [noticelists, setnoticelists] = useState([]); 
    const [rollingpopflag, setrollingpopflag] = useState(false); 

    const [mobilebuttonflag, setmobilebuttonflag] = useState(false); 
    const [mobilemyinfoflag, setmobilemyinfoflag] = useState(false); 
    const [memberinfos, setmemberinfos] = useState(''); 
      
    const GUIDE_PATH_LIST = [
        '/Main','/Product','/Customer','/Mypage','/CompanyNotice','/Membercontrol','/Workstat',
        '/Setoutside','/ApplicationList','/Deletelist','/Contactus','/Setminihome','/CompanyInfo',
        '/Workstatceo', '/'
    ]
    const [guideStep , setGuideStep] = useState({step:0,subStep:0});
    //{memberinfos?.compony
        
        
    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/alarm/list', sender).then(({ data }) => {
            if(data){
                console.log(data?.length);
                if(data?.length > 0){
                    setalramdot(true);
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });           

        sender = {
            rolling: true
        }
        APIS.postData('/v1/news/list', sender).then(({ data }) => {
            if(data){
                data.sort(function (a, b) {
                    if(a.hasOwnProperty('required')){
                        return b.required - a.required;
                    }
                });
                setnoticelists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });    
    }
  
    useEffect(() => {
        let timers = null;
        if(noticelists?.length > 0){
            let counts = 0;
            timers = setInterval(() => {
                //console.log(counts, noticelists?.length);
                if(counts*1 >= noticelists?.length-1){
                    counts = 0;
                } else {
                    counts = counts+1;
                }

                elementRef?.current?.scrollTo({
                    top: counts*20,
                    behavior: "smooth",
                });

            }, 5000);
        }
        return () => {
            clearInterval(timers);
        }
    }, [noticelists]);

    const componyAlert = () => {
        dispatch(
            open({
                component: `사무소 등록·소속 후 이용 가능합니다.`,
                title: '알림',
                titleviewer: true,
                alert: false,
                button: "확인",
                onPress: () => {
                    dispatch(close());
                }
            })
        );  
    }

    const penaltyCker = (types='simple') => {
        let sender = {}
        console.log(sender);
       
        APIS.postData('/v1/item/penaltyCker', sender).then(({ data }) => {
            if(data){
                if(types === 'simple'){
                    setsimplewrite(true); 
                } else {
                    setdetailwrite(true); 
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,                 
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );   
        }).finally(() => {
        });   
    }

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(()=>{
        if(window.location.hash !== '#guide'){
            setGuideStep({step:0,subStep:0})
        }
    },[window.location.hash])

    return(
        <>
        {bellshowflag === true && <AlertPopup setbellshowflag={setbellshowflag} setproductIdx={setproductIdx} setproducttogethersendflag={setproducttogethersendflag} setproducttogetherconfirmflag={setproducttogetherconfirmflag} /> }
        {producttogethersendflag === true && <ProductTogetherSendPop setbellshowflag={setbellshowflag} productIdx={productIdx} setproducttogethersendflag={setproducttogethersendflag} /> }
        {producttogetherconfirmflag === true && <ProductTogetherConfirmPop setbellshowflag={setbellshowflag} productIdx={productIdx} setproducttogetherconfirmflag={setproducttogetherconfirmflag} /> }
        {simplewrite === true && <ProductSimplewrite setsimplewrite={setsimplewrite} setselltypeproduct={setsell_type} setcategory_1product={setcategory_1} setcategory_2product={setcategory_2} /> }
        {detailwrite === true && <ProductDetailwrite setdetailwrite={setdetailwrite} setselltypeproduct={setsell_type} setcategory_1product={setcategory_1} setcategory_2product={setcategory_2} uidx={null} /> }
        {customerwirte === true && <CustomerWrite setdetailwrite={setcustomerwirte} setselltypeproduct={setsell_type} setcategory_1product={setcategory_1} setcategory_2product={setcategory_2} /> }

        {guideStep.step > 0 && <Guide viewinnerContentIdx={guideStep.subStep} viewaccordianStep={guideStep.step} onClose={()=>{
            navigate(-1);
            setGuideStep({step:0,subStep:0})
        }}/>}
        {(GUIDE_PATH_LIST.includes(location.pathname) || simplewrite || detailwrite || customerwirte ) && 
        <GuideButton onClick={()=>{
            window.location.hash = "#guide";
            if(simplewrite){
                setGuideStep({step:2,subStep:3}) // 간편접수
            } else if (detailwrite){
                setGuideStep({step:2,subStep:4}) // 상세접수
            } else if (customerwirte){
                setGuideStep({step:3,subStep:3}) // 고객접수
            } else if(location.pathname === "/Main" || location.pathname === "/"){
                setGuideStep({step:1,subStep:1}) // 홈화면
            } else if(location.pathname === "/Product") {
                if(detailFlag){
                    setGuideStep({step:2,subStep:7}) // 매물상세
                }else if (detailFlag2){
                    setGuideStep({step:2,subStep:6}) // 매물장
                }else{
                    setGuideStep({step:2,subStep:1}) // 매물리스트
                }
            } else if(location.pathname === "/Customer") {
                if(detailFlag){
                    setGuideStep({step:3,subStep:5}) // 고객상세
                }else{
                    setGuideStep({step:3,subStep:1}) // 고객리스트
                }
            } else if(location.pathname === "/Mypage") {
                setGuideStep({step:4,subStep:1})    // 개인설정
            } else if(location.pathname === "/CompanyNotice"){
                setGuideStep({step:4,subStep:2})    //사무소 관리
            } else if(location.pathname === "/CompanyInfo"){
                setGuideStep({step:4,subStep:3})    //사무소 정보
            } else if(location.pathname === "/Membercontrol"){
                setGuideStep({step:4,subStep:4})    //직원관리
            } else if(location.pathname === "/Workstat"){
                setGuideStep({step:4,subStep:5})    //업무통계
            } else if (location.pathname === "/Workstatceo"){
                setGuideStep({step:4,subStep:6})    //업무통계 전체
            } else if(location.pathname === "/Setoutside"){
                setGuideStep({step:4,subStep:7})    //외부 광고 설정 아싸점포
            } else if(location.pathname === "/Setminihome"){
                setGuideStep({step:4,subStep:8})    //외부 광고 설정 미니홈
            } else if(location.pathname === "/ApplicationList"){
                setGuideStep({step:4,subStep:9})    //소속신청관리
            } else if(location.pathname === "/Deletelist"){
                setGuideStep({step:4,subStep:10})    //삭제된매물
            } else if(location.pathname === "/Contactus"){
                setGuideStep({step:4,subStep:11})    //문의하기
            }else{
                window.location.hash = ""
            }
        }}/>}

        
        <div className='mainHeader'>
            <div className='logoandmenu'>
                <div onClick={() => { navigate('/'); }} style={{ cursor: 'pointer' }}>
                    {/* {companylogourl ? 
                        <img src={companylogourl} style={{ height: 40 }} />
                    :
                        <>LOGO</>
                    } */}
                    <img src="./images/logo.png" style={{ height: 30 }} /> 
                </div>
                <div>
                    

                    {memberinfos?.compony ?
                        <>
                        <Button buttonTxt={'홈'} className={`headerbutton ${actives === '0' ? 'active' : ''}`} onPress={() => navigate('/Main') } />
                        <span></span>
                        <Button buttonTxt={'매물'} className={`headerbutton ${actives === '1' ? 'active' : ''}`} onPress={() => navigate('/Product') } />
                        <span></span>
                        <Button buttonTxt={'고객'} className={`headerbutton ${actives === '2' ? 'active' : ''}`} onPress={() => navigate('/Customer') } />
                        <span></span>
                        <Button buttonTxt={'일정'} className={`headerbutton ${actives === '3' ? 'active' : ''}`} onPress={() => navigate('/Schedules') } />
                        <span className='mobileviewnone'></span>
                        <Button buttonTxt={'계약'} className={`headerbutton mobileviewnone ${actives === '4' ? 'active' : ''}`} onPress={() => navigate('/Contract') } />
                        <span className='mobileviewnone'></span>
                        <Button buttonTxt={'의뢰'} className={`headerbutton mobileviewnone ${actives === '5' ? 'active' : ''}`} onPress={() => navigate('/Outsidelist') } />
                        {/* <Button buttonTxt={'의뢰'} className={`headerbutton mobileviewnone ${actives === '5' ? 'active' : ''}`} onPress={() => { 
                                    dispatch(
                                        open({
                                            component: `의뢰매물 기능은 현재 준비중입니다.`,
                                            title: '알림',
                                            titleviewer: true,
                                            alert: false,
                                            button: "확인",
                                            onPress: () => {
                                                dispatch(close());
                                            }
                                        })
                                    );  
                        } } /> */}
                        <span className="mobileviewnone"></span>
                        <Button buttonTxt={"커뮤니티"} className={`headerbutton w-120 mobileviewnone communityHeader ${ actives === "6" ? "active" : ""}`}
                            onPress={() => navigate("/FreeCommunity")}
                        />
                        </>
                    :
                        <>
                        <Button buttonTxt={'홈'} className={`headerbutton ${actives === '0' ? 'active' : ''}`} onPress={() => {} } />
                        <span></span>
                        <Button buttonTxt={'매물'} className={`headerbutton ${actives === '1' ? 'active' : ''}`} onPress={() => { navigate('/Product') } } />
                        <span></span>
                        <Button buttonTxt={'고객'} className={`headerbutton ${actives === '2' ? 'active' : ''}`} onPress={() => { navigate('/Customer') } } />
                        <span></span>
                        <Button buttonTxt={'일정'} className={`headerbutton ${actives === '3' ? 'active' : ''}`} onPress={() => { navigate('/Schedules') } } />
                        <span className='mobileviewnone'></span>
                        <Button buttonTxt={'계약'} className={`headerbutton mobileviewnone ${actives === '4' ? 'active' : ''}`} onPress={() => { navigate('/Contract') } } />
                        <span className='mobileviewnone'></span>
                        <Button buttonTxt={'의뢰'} className={`headerbutton mobileviewnone ${actives === '5' ? 'active' : ''}`} onPress={() => {} } />
                        <span className="mobileviewnone"></span>
                        <Button buttonTxt={"커뮤니티"} className={`headerbutton w-120 mobileviewnone communityHeader ${ actives === "6" ? "active" : ""}`}
                            onPress={() => navigate("/FreeCommunity")}
                        />
                        </>
                    }
                </div>
                <div className='headernotice'>
                    <div
                        className='rollingnotice'
                    >
                        <div
                            ref={elementRef}
                        >
                            {noticelists.map((x, i) => {
                                return (
                                    <div 
                                        key={"headernotice"+i}
                                        onClick={() => {
                                            //setnoticepage(noticepage+1);
                                        }}
                                    >
                                        <span>공지</span>
                                        <span 
                                            style={{ cursor: 'pointer'}}
                                            onClick={() => {
                                                navigate('/NoticeDetail', {state: { vidx: x?.idx }});
                                            }}
                                        >
                                            <div className='textcut_online' style={{ color: '#fff'}}>{x?.title}</div>
                                        </span>
                                    </div>
                                );
                            })}

                        </div>
                        <button 
                            className='rollingnoticeArrow'
                            type='button'
                            onClick={() => {
                                setrollingpopflag(!rollingpopflag);
                            }}
                        >
                            <img src={`./images/icons/chevron-${rollingpopflag === true ? 'up' : 'down'}.svg`} />
                        </button>
                    </div>
                    {rollingpopflag === true &&
                    <div className='headernoticelisttop10'>
                        {noticelists.map((x, i) => {
                            return (
                                <div key={"headernoticelisttop10"+i}>
                                    <div
                                        style={{ cursor: 'pointer'}}
                                        onClick={() => {
                                            navigate('/NoticeDetail', {state: { vidx: x?.idx }});
                                        }}                                
                                    >
                                        <div className='textcut_online' style={{width: '100%'}} >{x?.title}</div>
                                    </div>
                                    <div>{moment(x?.create_dt).format('YYYY.MM.DD')}</div>
                                </div>
                            );
                        })}
                    </div>}
                </div>
            </div>
            
            
            {(userdata?.login === true && memberinfos?.compony) ?
            <div className='headerbtandprofile'>
                <div>
                    <Button titleimgs={'./images/icons/alarm_warning_line.svg'} buttonTxt={'오류신고'} className={'headerwritebutton'} onPress={() => { 
                        navigate('/Contactus',{state:{type:"contactClick"}});
                    }} />
                    {/* <Button titleimgs={'./images/icons/Ok.svg'} buttonTxt={'간편 등록'} className={'headerwritebutton'} onPress={() => { 
                        penaltyCker('simple');
                    }} />
                    <Button titleimgs={'./images/icons/Document.svg'} buttonTxt={'상세 등록'} className={'headerwritebutton'} onPress={() => { 
                        penaltyCker('detail');
                    }} />
                    <Button titleimgs={'./images/icons/Contacts.svg'} buttonTxt={'고객 등록'} className={'headerwritebutton'} onPress={() => { 
                        let sender = {}
                        console.log(sender);

                        APIS.postData('/v1/customer/penaltyCker', sender).then(({ data }) => {
                            if(data){
                                setcustomerwirte(true); 
                            }
                        }).catch(({ response }) => {
                            const { data } = response;
                            dispatch(
                                open({
                                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                    title: '알림',
                                    button: "확인",
                                    titleviewer: true,                 
                                    alert: false,
                                    onPress: () => {
                                        dispatch(close());
                                    },
                                })
                            );   
                        }).finally(() => {
                        });                           
                        
                    }} /> */}
                </div>
                <div onClick={() => {
                    setbellshowflag(!bellshowflag);
                }}>
                    <img src={'./images/icons/bell.svg'} width={24} />
                    {alramdot === true &&
                        <img src={'./images/icons/dotorange.svg'} className='dots' width={10} />
                    }
                </div>
                <div 
                onClick={() => { 
                    let windowwidth = window.innerWidth;
                    if(windowwidth < 1300){
                        setmobilemyinfoflag(!mobilemyinfoflag);
                    } else {
                        navigate('/Mypage') 
                    }
                }}
                style={{
                    backgroundImage: `${memberinfos?.profile ? "url('"+ consts.s3url +"/"+ memberinfos?.profile +"')" : "url('./images/icons/nouser.svg')"}`,
                    backgroundSize: `${memberinfos?.profile ? "cover" : ""}`, borderRadius: 100,
                    width: 36, height: 36
                }}  
                >
                    {!memberinfos?.profile && 
                        <div
                            style={{
                                width: '100%', height: '100%', backgroundColor: '#6164A5', borderRadius: 100,
                                border: '1px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                color: '#fff', fontWeight: 700, fontSize: 15
                            }}
                        >
                            {memberinfos?.name?.substr(0, 1)}
                        </div>
                    }
                </div>
            </div>
            :
            <div className='headerbtandprofile'>
                <div style={{ cursor: 'pointer' }} onClick={() => { 
                    let windowwidth = window.innerWidth;
                    if(windowwidth < 1300){
                        setmobilemyinfoflag(!mobilemyinfoflag);
                    } else {
                        navigate('/Mypage') 
                    }
                    
                }}>
                    <img src={'./images/icons/nouser.svg'} width={36} />
                </div>
            </div>            
            }
        </div>
        {mobilemyinfoflag === true &&
        <div className='mobilemyinfo'>
            <MypageleftArea />
        </div>
        }
        {userdata?.login === true &&
        <div className='mobilewriteButtons'>
            <div>
                {mobilebuttonflag === true &&
                <>
                    {/* <div><Button titleimgs={'./images/icons/alarm_warning_line.svg'} buttonTxt={'오류 신고'} className={'headerwritebutton'} onPress={() => { navigate('/Contactus',{state:{type:"contactClick"}}) }} /></div> */}
                    <div style={{ cursor: "pointer"}} onClick={() => { 
                        if(memberinfos?.compony){
                            setcustomerwirte(true); 
                        } else {
                            componyAlert();
                        }
                        }}><img src={'./images/icons/mobilebuttton1.svg'} /></div>
                    <div style={{ cursor: "pointer"}} onClick={() => { 
                        if(memberinfos?.compony){
                            setdetailwrite(true); 
                        } else {
                            componyAlert();
                        }
                        
                        }}><img src={'./images/icons/mobilebuttton2.svg'} /></div>
                    <div style={{ cursor: "pointer"}} onClick={() => { 
                        if(memberinfos?.compony){
                            setsimplewrite(true); 
                        } else {
                            componyAlert();
                        }
                    }}><img src={'./images/icons/mobilebuttton3.svg'} /></div>
                </>
                }
            </div>
            
            <div>
                <button
                    onClick={() => {
                        setmobilebuttonflag(!mobilebuttonflag);
                    }}
                >
                    {mobilebuttonflag === false ? 
                    <img src={'./images/icons/mobileplus.png'} width={70} />
                    :
                    <img src={'./images/icons/mobileclose.png'} width={70} />        
                    }
                </button>              
            </div>
        </div>
        }
        {footters === false ?
        <div className="mainfullpages pageViewer">{children}</div>
        :
        <div className="mainwrapper pageViewer">
            {children}
        </div>  
        }
        {footters === true &&
        <div className='mainFooter'>
            <div>
                <Button 
                    buttonTxt={'이용약관'} className={'footerbutton'} 
                    onPress={() => {
                        navigate('/Agree1');
                        // let sender = {
                        //     type: 1
                        // }
                        // APIS.postData('/term', sender).then(({ data }) => {
                        //     //console.log(data);
                        //     const PopComponents = () => {
                        //         return (
                        //             <div 
                        //             dangerouslySetInnerHTML={{__html: data}}
                        //             className='termContetns' 
                        //             />
                                    
                        //         );
                        //     }
                        //     dispatch(
                        //         open({
                        //             component: <PopComponents />,
                        //             title: '서비스 이용 약관',
                        //             titleviewer: true,                 
                        //             alert: false,
                        //         })
                        //     );  
                        // }).catch((e) => {
                        // }).finally(() => {
                        // });                        
                    }}
                />
                <span></span>
                <Button 
                    buttonTxt={'개인정보처리방침'} className={'footerbutton'} 
                    onPress={() => {
                        navigate('/Agree2');
                        // let sender = {
                        //     type: 2
                        // }
                        // APIS.postData('/term', sender).then(({ data }) => {
                        //     //console.log(data);
                        //     const PopComponents = () => {
                        //         return (
                        //             <div 
                        //             dangerouslySetInnerHTML={{__html: data}}
                        //             className='termContetns' 
                        //             />
                                    
                        //         );
                        //     }
                        //     dispatch(
                        //         open({
                        //             component: <PopComponents />,
                        //             title: '개인정보처리방침',
                        //             titleviewer: true,                 
                        //             alert: false,
                        //         })
                        //     );  
                        // }).catch((e) => {
                        // }).finally(() => {
                        // });                        
                    }}                    
                />
                <span></span>
                <Button 
                    buttonTxt={'고객센터'} className={'footerbutton'} 
                    onPress={() => {
                        navigate('/Noticelist');
                    }}
                />
            </div>
            <div>
                {/* <p>㈜모두의 매물</p> */}
                <p style={{ fontSize: 14 }}>에이피링스 주식회사</p>
                <p>{configdata?.footer?.addr}</p>
                <p>대표 : {configdata?.footer?.ceo}   사업자등록번호 : {configdata?.footer?.buisness_num}</p>
                {/* <p>전화번호: 02-0000-0000   |  대표메일:  ymetm-s2000@hanmail.net</p> */}
                <p>대표메일:  {configdata?.footer?.email}</p>
                <p>Copyright 에이피링스 주식회사 LTD All Rights Reserved.</p>
                <div>
                    {/* <Button titleimgs={'./images/icons/Frame1897.svg'} className={'notcss'} />
                    <Button titleimgs={'./images/icons/Frame1898.svg'} className={'notcss'} />
                    <Button titleimgs={'./images/icons/Frame1899.svg'} className={'notcss'} /> */}
                </div>
            </div>
        </div>
        }
        </>
    )
}

